import A from './types';

const initialState = {
  saveContactInfo: {},
  accountBuyerInfo: {
    isGeted: false,
    loading: false,
    error: false,
    data: {},
  },
  hpPaymentInfo: {
    isGeted: false,
    loading: false,
    error: false,
    data: {},
  },
  hpPlanInfo: {
    loading: false,
    error: false,
    data: {},
  },
  createOrder: {
    loading: false,
    error: false,
    data: {},
  },
  saveBsicInfo: {
    loading: false,
    error: false,
    data: {},
  },
  pay: {
    loading: false,
    error: false,
    data: {},
  },
  paymentInfo: {
    loading: false,
    error: false,
    data: {},
  },
};

const reducer = (state, action) => {
  switch (action.type) {
    case A.JUDGE_IS_BUYER_OR_NOT: {
      if(action.pending){
        return {
          ...state,
          accountBuyerInfo: {
            isGeted: false,
            loading: true,
            error: false,
          }
        }
      }
      if (action.payload.message.toLowerCase() === 'success') {
        return {
          ...state,
          accountBuyerInfo: {
            isGeted: true,
            loading: false,
            error: false,
            data: action.payload.data,
          },
        };
      }
      return {
        ...state,
        accountBuyerInfo: {
          isGeted: true,
          loading: false,
          error: action.payload.message ? action.payload.message : action.payload.state_message,
        },
      };
    }
    case A.GET_PAYMENT_INFO: {
      if (action.pending) {
        return {
          ...state,
          hpPaymentInfo: {
            isGeted: false,
            loading: true,
            error: false,
          },
        };
      }
      if (action.payload.state_message && action.payload.state_message.toLowerCase() === 'success') {
        return {
          ...state,
          hpPaymentInfo: {
            isGeted: true,
            loading: false,
            error: false,
            data: action.payload.data,
          },
        };
      }
      return {
        ...state,
        hpPaymentInfo: {
          isGeted: true,
          loading: false,
          error: action.payload.message ? action.payload.message : action.payload.state_message,
        },
      };
    }
    case A.HP_GET_PLANS_INFO: {
      if (action.pending) {
        return {
          ...state,
          hpPlanInfo: {
            loading: true,
            error: false,
          },
        };
      }
      if (action.payload.state_message && action.payload.state_message.toLowerCase() === 'success') {
        return {
          ...state,
          hpPlanInfo: {
            loading: false,
            error: false,
            data: action.payload.data,
          },
        };
      }
      return {
        ...state,
        hpPlanInfo: {
          loading: false,
          error: action.payload.message ? action.payload.message : action.payload.state_message,
        },
      };
    }
    case A.HP_PALN_MODES_INIT: {
      return {
        ...state,
        hpPlanInfo: {
          loading: false,
          error: false,
          data: {},
        },
      };
    }
    case A.HP_CREATE_ORDER : {
      if (action.pending) {
        return {
          ...state,
          createOrder: {
            loading: true,
            error: false,
          },
        };
      }
      if (action.payload.state_message && action.payload.state_message.toLowerCase() === 'success') {
        return {
          ...state,
          createOrder: {
            loading: false,
            error: false,
            data: action.payload.data,
          },
        };
      }
      return {
        ...state,
        createOrder: {
          loading: false,
          error: action.payload.message ? action.payload.message : action.payload.state_message,
        },
      };
    }
    case A.HP_SAVE_BASIC_INFO : {
      if (action.pending) {
        return {
          ...state,
          saveBsicInfo: {
            loading: true,
            error: false,
            data: {},
          },
        };
      }
      if (action.payload.message === 'success') {
        return {
          ...state,
          saveBsicInfo: {
            loading: false,
            error: false,
            data: action.payload.data,
          },
        };
      }
      return {
        ...state,
        createOsaveBsicInforder: {
          loading: false,
          error: true,
          data: {},
        },
      };
    }
    case A.HP_GET_PAYMENT_INFO : {
      if (action.pending) {
        return {
          ...state,
          paymentInfo: {
            loading: true,
            error: false,
          },
        };
      }
      if (action.payload.state_message && action.payload.state_message.toLowerCase() === 'success') {
        return {
          ...state,
          paymentInfo: {
            loading: false,
            error: false,
            status: action.payload.state_message.toLowerCase(),
            data: action.payload.data,
          },
        };
      }
      return {
        ...state,
        paymentInfo: {
          loading: false,
          error: action.payload.message ? action.payload.message : action.payload.state_message,
        },
      };
    }
    case A.HP_PAY_ORDER : {
      if (action.pending) {
        return {
          ...state,
          pay: {
            loading: true,
            error: false,
            data: {},
          },
        };
      }
      if (action.payload.state_message && action.payload.state_message.toLowerCase() === 'success') {
        return {
          ...state,
          pay: {
            loading: false,
            error: false,
            data: action.payload.data,
          },
        };
      }
      return {
        ...state,
        pay: {
          loading: false,
          error: action.payload.message ? action.payload.message : action.payload.state_message,
          data: {},
        },
      };
    }
    case A.HP_PAGE_ASYNG_ERROR_HIDE: {
      return {
        ...state,
        [action.payload.type]: {
          ...[action.payload.type],
          error: false,
          childError: false,
        },
      };
    }
  }
  return null;
};

export default {reducer, initialState};



// WEBPACK FOOTER //
// ./src/modules/hp/reducer.js